import EcheckNiquel from "../../components/E-check/EcheckNiquel";

export default function () {
  return (
    <EcheckNiquel />
  );
}
